import React from "react";
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaTimesCircle,
} from "react-icons/fa";

const ICONS = {
  error: FaTimesCircle,
  info: FaInfoCircle,
  success: FaCheckCircle,
  warning: FaExclamationTriangle,
};

const BrokerAlert = ({
  actionLabel,
  children,
  icon,
  onAction,
  title,
  type = "info",
}) => {
  const normalizedType = ICONS[type] ? type : "info";
  const Icon = icon || ICONS[normalizedType];
  const role = normalizedType === "error" ? "alert" : "status";

  return (
    <div className={`broker-state-alert broker-state-alert--${normalizedType}`} role={role}>
      <span className="broker-state-alert__icon" aria-hidden="true">
        <Icon />
      </span>
      <div className="broker-state-alert__content">
        {title ? <strong>{title}</strong> : null}
        {children ? <span>{children}</span> : null}
      </div>
      {actionLabel && onAction ? (
        <button type="button" className="broker-link-button" onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
};

export default BrokerAlert;
